const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/notifications/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { AREA_FILTERS } from '@tempo-io/notification-dto';
import { z } from 'zod';
import i18n from '@/common/translations/i18n';
import { NOTIFICATION_VIEWS, TIME_RANGE_FILTERS } from '@/features/notifications/api/notificationsApi';
export const Route = createFileRoute('/(app)/org/$org/notifications/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: z.object({
    view: z.enum(NOTIFICATION_VIEWS).catch('inbox'),
    area: z.enum(AREA_FILTERS).catch('all'),
    timeRange: z.enum(TIME_RANGE_FILTERS).catch('all'),
    customFrom: z.string().datetime().optional().catch(undefined),
    customTo: z.string().datetime().optional().catch(undefined)
  }),
  loader: (): LoaderData => ({
    crumb: i18n.t($ => $.notifications.inbox.title)
  }),
  staticData: {
    hideChrome: true,
    topNav: {
      title: i18n.t($ => $.notifications.inbox.title)
    }
  }
});